import React from 'react';
import { formatNumber } from '../../commons';

const ArrowLeft = () => (
  <svg width='16' height='16' viewBox='0 0 24 24' fill='none'>
    <path d='M15 19l-7-7 7-7' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
  </svg>
);

const ArrowRight = () => (
  <svg width='16' height='16' viewBox='0 0 24 24' fill='none'>
    <path d='M9 5l7 7-7 7' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
  </svg>
);

const getPageIndices = (begin, end) => {
  const indices = [];

  for (let i = begin; i <= end; i++) {
    indices.push(i);
  }

  return indices;
}

const Pagination = ({
  totalOfRows,
  page,
  perPage,
  onNavigate,
}) => {

  if (totalOfRows <= perPage) {
    return null;
  }

  const numberEdgePages = 1;
  const numberMiddlePages = 4;

  const disableNextPageButton = !(
    page * perPage < totalOfRows
  );

  const disablePrevPageButton = page === 1;
  const totalPages = Math.ceil(totalOfRows / perPage);

  const beginPages = [1];
  const endPages = [totalPages];

  const startingMiddlePages = Math.min(
    page - Math.floor(numberMiddlePages / 2) + 1,
    totalPages - numberEdgePages - numberMiddlePages,
  );

  const middlePagesBegin = Math.max(startingMiddlePages, numberEdgePages + 2);
  const middlePagesEnd = Math.min(
    Math.max(
      page + Math.floor(numberMiddlePages / 2),
      numberEdgePages + numberMiddlePages + 1,
    ),
    endPages.length > 0 ? endPages[0] - 2 : totalPages - 1,
  );

  const middlePages = getPageIndices(middlePagesBegin, middlePagesEnd);

  let beginFlex = [];

  if(middlePagesBegin > numberEdgePages + 2) beginFlex= ['separator'];
  else if(numberEdgePages + 1 < totalPages - numberEdgePages)
    beginFlex = [numberEdgePages + 1];

  let endFlex = [];

  if (middlePagesEnd < totalPages - numberEdgePages - 1)
    endFlex = ['separator'];
  else if (totalPages - numberEdgePages > numberEdgePages)
    endFlex = [totalPages - numberEdgePages];

  const controls = [
    ...beginPages,
    ...beginFlex,
    ...middlePages,
    ...endFlex,
    ...endPages,
  ];

  return (
    <div className='pagination'>
      <button
        className='pagination__arrow'
        onClick={() => onNavigate(page - 1)}
        disabled={disablePrevPageButton}
        title='Página anterior'
      >
        <ArrowLeft />
      </button>

      <div className='pagination__pages'>
        {controls.map((control, index) => {
          if (control === 'separator') {
            return (
              <span key={index} className='pagination__separator'>
                ...
              </span>
            );
          }

          const isCurrentPage = page === control;

          return (
            <button
              key={index}
              className={`pagination__page ${isCurrentPage ? 'pagination__page--active' : ''}`}
              onClick={() => onNavigate(control)}
              disabled={isCurrentPage}
            >
              {formatNumber(control)}
            </button>
          );
        })}
      </div>

      <button
        className='pagination__arrow'
        onClick={() => onNavigate(page + 1)}
        disabled={disableNextPageButton}
        title='Próxima página'
      >
        <ArrowRight />
      </button>
    </div>
  )
}

export default Pagination;
